export const SDK_ENDPOINT = 'sdk.fra-01.braze.eu'
export const EVENT_PLATFORM = 'web'
